module.exports = "<div *ngIf=\"adminConfig?.activated\" class=\"container-fuild\">\n    <div class=\"exclamation-icon item\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i></div>\n    <p class=\"info\">{{adminConfig.info}}</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/trc-admin-config/trc-admin-config.component.html
// module id = 858
// module chunks = 0